var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-global"},[_c('base-nav',{staticClass:"navbar-main",attrs:{"transparent":"","type":"","effect":"light","expand":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }